export const feedbackKeys = {
	all: ['feedback'] as const,
	lists: () => [...feedbackKeys.all, 'list'] as const,
	list: (filters: Record<string, unknown>) => [...feedbackKeys.lists(), filters] as const,
	details: () => [...feedbackKeys.all, 'detail'] as const,
	detail: (id: number) => [...feedbackKeys.details(), id] as const,
	stats: () => [...feedbackKeys.all, 'stats'] as const,
	mine: () => [...feedbackKeys.all, 'mine'] as const,
	votable: () => [...feedbackKeys.all, 'votable'] as const,
};
